import React from 'react';
import {learnerGroupsText} from './learnerGroupsText';
import styles from './AudienceToggle.module.css';

export type Audience = 'learners' | 'groups';

interface Props {
  audience: Audience;
  onChange: (audience: Audience) => void;
}

const AudienceToggle = React.memo(({audience, onChange}: Props) => (
  <div className={styles.toggle} role="tablist">
    <button
      type="button"
      role="tab"
      aria-selected={audience === 'learners'}
      className={`${styles.option} ${
        audience === 'learners' ? styles.optionActive : ''
      }`}
      onClick={() => onChange('learners')}>
      {learnerGroupsText.learners}
    </button>
    <button
      type="button"
      role="tab"
      aria-selected={audience === 'groups'}
      className={`${styles.option} ${
        audience === 'groups' ? styles.optionActive : ''
      }`}
      onClick={() => onChange('groups')}>
      {learnerGroupsText.groups}
    </button>
  </div>
));

export default AudienceToggle;
